import PdfView from '@/pages/pdf/View'

export default [
  {
    path: '/pdf/view',
    name: 'PdfView',
    component: PdfView,
    meta: {
      noContainer: true,
      fullPage: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/pdf/index.js